<mat-checkbox #control
              (change)="valueChanged(value)"
              [(ngModel)]="value"
              [disabled]="disabled">
    <span>{{label}}</span>
</mat-checkbox>